<template>
  <expandable header="Resuscitative measures" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <print-yes-no
          v-model="form.CPR_given"
          label="CPR Given"
          @input="onInput"
          :disabled="isDisabled"
          rules="required"
        ></print-yes-no>
      </b-col>

      <b-col cols="12" md="4" v-if="form.CPR_given == 1">
        <print-file-input
          v-model.trim="form.CPR_notes"
          @input="onInput"
          :disabled="isDisabled"
          label="CPR File"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="required|file-image-pdf|file-size"
        ></print-file-input>
      </b-col>
      <b-col cols="12" md="4">
        <print-yes-no
          v-model="form.hypotensive_episodes"
          label="Hypotensive Episodes"
          @input="onInput"
          :disabled="isDisabled"
          rules="required"
        ></print-yes-no>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import PrintFileInput from "../../ui/print/PrintFileInput.vue";
import PrintYesNo from "../../ui/print/PrintYesNo.vue";
export default {
  components: { Expandable, PrintFileInput, PrintYesNo },
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
};
</script>

<style></style>
